import React, { useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Cart.css";
import { useState } from "react";
import TitleSectionComponent from "../../Components/TitleSectionComponent/TitleSectionComponent";
import { BsBasket } from "react-icons/bs";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import CartItem from "./CartItem";
import Swal from "sweetalert2";
import { isLoggedIn } from "../../Hooks/isLoggedIn";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UserPanelEmptyAlert from "../../Components/UserPanelEmptyAlert/UserPanelEmptyAlert";
import { MdOutlineRemoveShoppingCart } from "react-icons/md";
import { CartContext } from "../../Hooks/CartContext";
import Zarinpal from '../../Assets/images/zarinpal.png'
import { Helmet } from "react-helmet-async";

export default function Cart() {
    const [items, setItems] = useState([]);
    const { cartItems, addToCart } = useContext(CartContext);
    let totalPrice = 0;
    const nav = useNavigate();

    useEffect(() => {
        if (isLoggedIn()) {
            axiosConfig
                .get("api/shoppingCart")
                .then((res) => {
                    setItems(res.data.items);
                });
        } else {
            toast.warning("لطفا وارد حساب کاربری خود شوید")
            nav('/')
        }
    }, []);

    const sendData = () => {
        axiosConfig.get('pay').then((res) => {
            window.location = res.data.data
        });
    }

    const changeQuantity = (itemId, change) => {
        let item = items.filter((a) => a.id === itemId)[0];
        if (item === null) return;
        if (change == -1 && item.quantity === 1) {
            return;
        }
        axiosConfig
            .put("api/shoppingCart", {
                itemId: item.id,
                change: change,
            })
            .then((res) => {
                if (res.status) {
                    addToCart(cartItems + change)
                    setItems((prev) => {
                        return prev.map((cartItem) => {
                            if (cartItem.id === itemId) {
                                return Object.assign({}, cartItem, {
                                    quantity: cartItem.quantity + change,
                                });
                            }
                            return cartItem;
                        });
                    });
                } else {
                    Swal.fire(
                        "خطا",
                        "در هنگام تغییر تعداد . خطایی رخ داده است",
                        "error"
                    );
                }
            });
    };

    const deleteItem = (itemId) => {
        axiosConfig.delete("api/shoppingCart?itemId=" + itemId).then((res) => {
            if (res.status) {
                const item = items.filter(p => p.id == itemId)[0];
                addToCart(cartItems - item.quantity);
                setItems((prev) => {
                    return prev.filter((item) => item.id !== itemId);
                });
            }
        });
    };

    return (
        <>
            <Helmet>
                <title>سبد خرید شما | مدیریت سفارشات در سه‌نیک</title>
                <meta
                    name="description"
                    content="محصولات انتخاب شده خود را در سبد خرید سه‌نیک بررسی و مدیریت کنید. پرداخت آسان و امن برای دوره‌ها، محصولات آموزشی و کاربردی."
                />
            </Helmet>
            <div className="Cart-section">
                <Container className="Cart-container">
                    <div className="Cart-title-box">
                        <h1 className="Cart-title">سبد خرید شما</h1>
                    </div>
                    <div className="Cart-title-res">
                        <TitleSectionComponent
                            title="سبد خرید شما"
                            icon={<BsBasket />}
                        />
                    </div>
                    <Row className="Cart-Row">
                        <Col lg={8}>
                            <div className="cart-table">

                                {items.length == 0 ? (
                                    <UserPanelEmptyAlert title='سبد خرید خالی است' icon={<MdOutlineRemoveShoppingCart />} />
                                ) : (
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>حذف</th>
                                                <th>محصول</th>
                                                <th>قیمت</th>
                                                <th>تعداد</th>
                                                <th>مجموع</th>
                                            </tr>
                                        </thead>
                                        <tbody>


                                            {items.map((cartItem) => {
                                                totalPrice +=
                                                    cartItem.price *
                                                    cartItem.quantity;
                                                return (
                                                    <CartItem
                                                        key={cartItem.id}
                                                        quantityChangeHandler={
                                                            changeQuantity
                                                        }
                                                        itemDeleteHandler={
                                                            deleteItem
                                                        }
                                                        item={cartItem}
                                                    />
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                            <div className="cart-table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>حذف</th>
                                            <th>محصول</th>
                                            <th>قیمت</th>
                                            <th>تعداد</th>
                                            <th>مجموع</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.length == 0 ? (
                                            <UserPanelEmptyAlert title='سبد خرید خالی است' icon={<MdOutlineRemoveShoppingCart />} />
                                        ) : items.map((cartItem) => {
                                            return (
                                                <CartItem
                                                    key={cartItem.id}
                                                    quantityChangeHandler={
                                                        changeQuantity
                                                    }
                                                    itemDeleteHandler={
                                                        deleteItem
                                                    }
                                                    item={cartItem}
                                                />
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="cart-total">
                                <div className="cart-total-title">
                                    <h3>جمع کل سبد خرید</h3>
                                </div>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <th scope="row">جمع کل</th>
                                            <td>
                                                {totalPrice.toLocaleString(
                                                    "fa-IR"
                                                )}
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <th>جمع با تخفیف</th>
                                            <td className="total-price">
                                                130,400
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>
                                <div className='payment-gateway'>
                                    <input type="radio" checked={true} />
                                    <div>
                                        <h3>پرداخت امن زرین پال</h3>
                                        <img src={Zarinpal} alt="" />
                                    </div>

                                </div>
                                <p className="zarin">
                                    پرداخت امن به وسیله کلیه کارت های عضو شتاب
                                </p>
                                <button onClick={sendData} className="card-table-btn">
                                    تکمیل خرید
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
